import { useMemo } from "react";
import { TaskGrid } from "../../components/TaskGrid/TaskGrid";
import { useBoardViews } from "../../contexts/views/viewsContext";
import ViewTitle from "../../layout/components/ViewTitle";
import Enums from "../../types/enums";

export const RelatedToMe = () => {
  const { systemViews } = useBoardViews();

  const rtmView = useMemo(
    () => systemViews.find((v) => v.ViewType === Enums.ViewType.RelatedToMe),
    [systemViews]
  );

  return (
    <>
      <div className="row">
        <ViewTitle viewId={rtmView?.Id} viewName={rtmView.Name} />
      </div>
      <div className="row">
        <TaskGrid viewId={rtmView?.Id} viewType={Enums.ViewType.RelatedToMe} />
      </div>
    </>
  );
};
